import { lazyLoad } from 'utils/loadable';

export const CandidatePageLoadable = lazyLoad(
  () => import('./CandidatePage'),
  module => module.default,
);
